import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { DocumentsState, selectDocumentsState } from '../documents-selectors';
import { CommunicationsState } from './communications-types';

export const getCommunicationDocumentsState:any = createDraftSafeSelector(
  selectDocumentsState,
  (state: DocumentsState) => {
    return state.communications;
  }
);
export const getCommunicationDocuments:any = createDraftSafeSelector(
  getCommunicationDocumentsState,
  (state: CommunicationsState) => {
    return state.communications;
  }
);

export const getCommunicationFilter:any = createDraftSafeSelector(
  getCommunicationDocumentsState,
  (state: CommunicationsState) => {
    return state.filter;
  }
);
